<template>
  <div id="accomodation-transfer">
    <div class="content-wrapper">
      <portal to="action-buttons"></portal>
      <div class="content animated fadeIn">
        <div class="card">
          <div class="card-header header-elements-inline" style="padding-bottom:0px;">
            <h5 class="card-title">{{$t("event.menu.accomodation.title")}} [Testing]</h5>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe(null)" icon="fas fa-life-ring" size="mini"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button icon="fas fa-redo-alt" size="mini"></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <PageCountInfo :total="0" :skip="0" :take="0" />

          <el-table
            ref="multipleTable"
            :data="[]"
            style="width: 100%"
            @selection-change="handleSelectionChange"
            :row-class-name="tableRowClassName"
          >
            <el-table-column :label="$t('event.table.queue')" property="orderNO" width="60"></el-table-column>

            <el-table-column property="title" label="Product" min-width="120"></el-table-column>
            <el-table-column property="title" label="Type" min-width="120"></el-table-column>
            <el-table-column property="title" label="Price" min-width="120"></el-table-column>
            <el-table-column property="title" label="Currency" min-width="120"></el-table-column>
            <el-table-column property="title" label="Quota/Usage" min-width="120"></el-table-column>
            <el-table-column property="title" label="Package" min-width="120"></el-table-column>
            <el-table-column property="title" label="Status" min-width="120"></el-table-column>

            <el-table-column align="center" :label="$t('event.table.processes')" width="110" fixed="right">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="$t('event.table.edit')" placement="top">
                  <el-button
                    type="primary"
                    icon="fas fa-pen"
                    circle
                    size="mini"
                    @click="
                      updateForm = JSON.parse(JSON.stringify(scope.row));
                      modalVisible = true;
                    "
                  ></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.table.delete')" placement="top">
                  <el-popconfirm
                    @confirm="deleteItem(scope.$index)"
                    :confirmButtonText="$t('event.variables.yes')"
                    :cancelButtonText="$t('event.buttons.cancel')"
                    icon="el-icon-info"
                    iconColor="red"
                    :title="$t('event.textbox.toDelete')"
                  >
                    <el-button
                      slot="reference"
                      type="danger"
                      icon="fas fa-trash"
                      circle
                      size="mini"
                    ></el-button>
                  </el-popconfirm>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="$store.state.areamaps.filter.page"
            :page-sizes="[20, 30, 40, 50]"
            :page-size="100"
            layout="total, sizes, prev, pager, next, jumper"
            :total="$store.state.areamaps.filter.total"
          ></el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ExcelImport from "../../components/ExcelImport";
import axios from "axios";
import PageCountInfo from "../../components/PageCountInfo";
import $ from "jquery";
export default {
  metaInfo: {
    title: "Accomodation, Transfer and Store",
  },
  components: { ExcelImport, PageCountInfo },
  name: "AccomodationTransfer",
  data() {
    return {
      modalVisible: false,
      updateForm: null,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "areamaps",
      widgetUrl:
        "https://cdn.holacon.com/widgets/event-speakers.html?applicationID=5e2b3b73286bd618b47d1e6e&amp;eventID=5e30227b83089521b86ef7bf",
      excelTemplateUrl:
        this.$excelTemplateUrl + "sample/SpeakerExcel/SpeakerImportSample.xlsx",
    };
  },
  methods: {
    itemUpdated(item) {
      var index = this.$store.state.areamaps.items.findIndex(
        (k) => k.id == item.id
      );
      if (index != -1) {
        this.$store.state.areamaps.items.splice(index, 1, item);
      }
    },
    itemAdded(item) {
      this.$store.dispatch("getAreaMaps");
    },
    handleSizeChange(take) {
      this.$store.commit("setAreaMapTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setAreaMapPage", page);
    },
    deleteItem(index) {
      this.$store.dispatch("deleteAreaMap", { index, context: this });
    },
    statusChanged(value, index) {
      this.$store.dispatch("toggleAreaMap", { index, value });
    },
    handleSelectionChange(items) {
      this.$store.commit("setSelectedAreaMaps", items);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    },
  },
  mounted() {
    this.$store.dispatch("getAreaMaps");
  },
  created() {},
  computed: {
    skip() {
      return (
        (this.$store.state.areamaps.filter.page - 1) *
        this.$store.state.areamaps.filter.take
      );
    },
    take() {
      return this.skip + this.$store.state.areamaps.items.length;
    },
  },
  watch: {
    "$store.state.areamaps.filter.searchTerm": function () {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getAreaMaps");
      }, 500);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/event/Accomodation.vue